import type { AxiosInstance } from 'axios';
import authService from './auth.service';

/**
 * The Terms and Conditions (0181).
 *
 *   GET  /api/v1/terms           public: the terms in force
 *   (accepting is the one screen after sign-in: legalDocuments.service.ts)
 */
export interface Terms {
  version: number;
  body_en: string;
  body_es: string;
  /** True while the text is a placeholder and not counsel's. */
  is_draft: boolean;
  /** When this version was published, which is when it took effect (no advance notice). */
  published_at: string;
}

class TermsService {
  private get api(): AxiosInstance {
    return authService.getApi();
  }

  async current(): Promise<Terms> {
    const res = await this.api.get<Terms>('/api/v1/terms');
    return res.data;
  }
}

export default new TermsService();
